import { RuleContent } from '@wix/rules-panel-ui';
import React, { useMemo } from 'react';
import { useCloseSelf } from './context/collapse-actions-context';
function hasOnCancel(fixerProps) {
  return typeof fixerProps === 'object' && fixerProps !== null && 'onCancel' in fixerProps && typeof fixerProps.onCancel === 'function';
}

/**
 * Wrapper component that enhances RuleContent with proper collapse behavior.
 * This component must be rendered inside ItemScopeProvider to have access
 * to the collapse context.
 */
export const RuleContentWithCollapse = _ref => {
  let {
    ruleResult
  } = _ref;
  const closeSelf = useCloseSelf();
  const enhancedRuleResult = useMemo(() => {
    if (!ruleResult.fixerProps) {
      return ruleResult;
    }
    const originalOnCancel = hasOnCancel(ruleResult.fixerProps) ? ruleResult.fixerProps.onCancel : undefined;
    return {
      ...ruleResult,
      fixerProps: {
        ...ruleResult.fixerProps,
        onCancel: () => {
          originalOnCancel == null || originalOnCancel();
          closeSelf();
        }
      }
    };
  }, [ruleResult, closeSelf]);
  return /*#__PURE__*/React.createElement(RuleContent, {
    ruleResult: enhancedRuleResult
  });
};
//# sourceMappingURL=rule-content-with-collapse.js.map